import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { Common } from 'ws-scripts/modules/common';
import Background from '../components/Background';
import ContentWrapper from '../components/ContentWrapper';
import { setHover } from '../actions/hover';
import { setClassNames } from '../utilities/classes';
import { setWidgetConfiguration } from '../utilities/configuration';
import { triggerTrackingEvent } from '../utilities/analytics';
import { getHtmlWithDLData } from '../utilities/helpers/text';
import '../global-sass/main.scss';

const setWrapperClassNames = (
	enableClickable,
	isHovered,
	imageLocation,
	...classes
) => {
	const classNames = ['cta', 'd-flex', 'position-relative', ...classes];

	if (
		imageLocation === 'background-right' ||
		imageLocation === 'background-left'
	) {
		classNames.push('flex-row');

		if (imageLocation === 'background-right') {
			classNames.push('flex-row-reverse');
		}
	} else {
		classNames.push('flex-column');
	}

	if (enableClickable) {
		classNames.push('pointer', 'text-no-decoration');

		if (isHovered) {
			classNames.push('hover');
		}
	}

	return setClassNames.apply(this, classNames);
};

const setStyles = (widgetHeight = null) => {
	const styles = {};

	if (widgetHeight) {
		styles.height = widgetHeight;
	}

	return styles;
};

const handleClick = (
	event,
	url,
	enableOpenNewWindow,
	elementCTA,
	windowId,
	isClickableModal
) => {
	event.preventDefault();

	triggerTrackingEvent(
		'ws-content-cta Call to action',
		elementCTA,
		`Navigated to ${url}`,
		windowId
	);

	if (!isClickableModal) {
		if (enableOpenNewWindow) {
			window.open(url);
		} else {
			window.location.href = url;
		}
	}
};
class WidgetContainer extends React.Component {
	render() {
		return (
			<Common
				render={({ prefs, labels, sitemap }) => {
					const { displayStyle } = prefs;
					const { deviceType, windowId } = this.props.widgetInfo;
					const { isHovered } = this.props.hover;
					const widgetConfiguration = setWidgetConfiguration(
						deviceType,
						isHovered,
						displayStyle,
						prefs,
						sitemap
					);
					const {
						widgetHeight,
						dialogWindowWidth,
						enableDialogWindow,
						enableOpenNewWindow,
						enableClickable,
						url,
						showButton,
						imageLocation,
						headingLabel,
						contentLabel,
						buttonLabel,
						accessibleDescription,
						dialogWindowTitleLabel,
						widgetBackgroundColor,
						widgetTransitionProperty,
						widgetTransitionTimingFunction,
						widgetTransitionDuration,
						backgroundWrapperWidth
					} = widgetConfiguration;

					const isClickable = enableClickable && url !== '';
					const isAnchorElement = isClickable && !showButton;
					const isClickableDivElement =
						isClickable && !isAnchorElement;
					const isClickableModal =
						enableDialogWindow &&
						(isClickableDivElement || isAnchorElement);
					const WidgetElement = isAnchorElement ? 'a' : 'div';
					const target =
						enableOpenNewWindow && !enableDialogWindow
							? '_blank'
							: '';

					const headingText =
						headingLabel && labels.getHTML(headingLabel);
					const dialogWindowTitleText = labels.get(
						dialogWindowTitleLabel
					);
					const ariaLabel = labels.get(accessibleDescription);

					return (
						<WidgetElement
							className={setWrapperClassNames(
								enableClickable,
								isHovered,
								imageLocation,
								widgetBackgroundColor,
								widgetTransitionProperty,
								widgetTransitionTimingFunction,
								widgetTransitionDuration,
								isClickableModal ? 'dialog' : ''
							)}
							style={setStyles(widgetHeight)}
							href={isAnchorElement ? url : null}
							aria-label={ariaLabel || null}
							aria-labelledby={
								!ariaLabel
									? `${windowId}-heading ${windowId}-button`
									: null
							}
							role={isClickableDivElement ? 'button' : null}
							data-href={isClickableModal ? url : null}
							data-modal={isClickableModal ? 'true' : null}
							data-title={
								isClickableModal && dialogWindowTitleText
									? dialogWindowTitleText
									: null
							}
							data-width={
								isClickableModal && dialogWindowWidth
									? dialogWindowWidth
									: null
							}
							target={isAnchorElement && target ? target : null}
							onClick={
								isClickable
									? event =>
											handleClick(
												event,
												url,
												enableOpenNewWindow,
												headingText,
												windowId,
												isClickableModal
											)
									: null
							}
							onMouseEnter={() =>
								enableClickable && this.props.setHover(true)
							}
							onMouseLeave={() =>
								enableClickable && this.props.setHover(false)
							}
						>
							{imageLocation !== 'foreground' && (
								<div
									className={backgroundWrapperWidth}
									style={{ overflow: 'hidden' }}
								>
									<Background {...widgetConfiguration} />
								</div>
							)}
							<ContentWrapper
								{...{
									widgetConfiguration,
									windowId,
									isClickableDivElement,
									imageLocation,
									headingText,
									contentText:
										contentLabel &&
										getHtmlWithDLData(
											labels.get(contentLabel)
										),
									buttonText:
										buttonLabel &&
										labels.getHTML(buttonLabel),
									dialogWindowTitleText,
									target
								}}
							/>
						</WidgetElement>
					);
				}}
			/>
		);
	}
}

WidgetContainer.propTypes = {
	hover: PropTypes.shape({
		isHovered: PropTypes.bool.isRequired
	}).isRequired,
	setHover: PropTypes.func.isRequired,
	widgetInfo: PropTypes.shape({
		deviceType: PropTypes.string.isRequired,
		windowId: PropTypes.string.isRequired
	}).isRequired
};

const mapStateToProps = state => {
	return {
		hover: state.hover,
		widgetInfo: state.widgetInfo
	};
};

const mapDispatchToProps = dispatch => ({
	setHover: isHovered => {
		dispatch(setHover(isHovered));
	}
});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;



// WEBPACK FOOTER //
// ./src/containers/Widget.jsx